import config from '@resn/gozer-core/config';

/**
 * Prefix the Shopify checkout url with a provided base
 * url supplied in dot env and config.
 * @param {} url
 */
export const prefixShopifyUrl = (url) => {
    const prefix = config.SHOPIFY_CHECKOUT_URL_PREFIX;
    const shopname = config.SHOPIFY_SHOPNAME;
    if (prefix && prefix !== '') {
        const prefixUrl = [
            'https:/',
            prefix,
            ...url.split('/').filter((s) => s.indexOf('http') === -1 && s.indexOf(shopname) === -1 && s !== ''),
        ].join('/');
        return prefixUrl;
    } else {
        return url;
    }
};
